import { forwardRef } from "react";

import styles from "./styles.module.scss";
import { LoginUser } from "assets/icons";
import useTranslation from "hooks/useTranslation";

const EnterCard = forwardRef(function EnterCard(
  { data, user, id, locale, userName },
  ref
) {
  const date = new Date(data.start);
  const locales = locale === "fa" ? "fa-IR" : undefined;
  const { getTranslation } = useTranslation("CHAT");
  const { t } = getTranslation();

  const weekDayName = date.toLocaleDateString(locales, {
    weekday: "long",
  });

  const dayNum = date.toLocaleDateString(locales, {
    day: "numeric",
  });

  const monthName = date.toLocaleDateString(locales, {
    month: "long",
  });

  const year = date.toLocaleDateString(locales, {
    year: "numeric",
  });

  const renderingDate = `${weekDayName}  -  ${dayNum}  ${monthName}  ${year}`;

  const rederingTime = date.toLocaleTimeString(locales, { hour12: false });

  return (
    <div
      ref={(el) => {
        ref.current[id] = el;
      }}
      className={styles.enter_card}
    >
      <div className={styles.enter_card__inner}>
        {/* head */}
        <div className={styles.enter_card__head}>
          <img className={styles.enter_card__icon} src={LoginUser} alt="" />
          <div className={styles.enter_card__user_name}>
            <span>{t("ROADMAP_MODAL").ENTER}</span>
            {"  "}
            <span title={user?.name || userName}>{user?.name || userName}</span>
          </div>
        </div>
        {/* date */}
        <div className={styles.enter_card__date}>{renderingDate}</div>
        {/* time */}
        <div className={styles.enter_card__time}>{rederingTime}</div>
      </div>
    </div>
  );
});

export default EnterCard;
